import type { MetaFunction } from "@remix-run/node";
import { getSeoMeta } from "~/utils/seo-meta";
import { SEOLayout } from "~/components/seo/SEOLayout";
import { GameSeoPage } from "~/components/seo/GameSeoPage";
import { GAME_SEO_CONFIG } from "~/utils/seo-game-content";

export const meta: MetaFunction = () => {
  const content = GAME_SEO_CONFIG.basketball;
  return getSeoMeta({
    title: content.title,
    description: content.description,
    url: "/seo/basketball",
  });
};

export default function SeoBasketball() {
  return (
    <SEOLayout>
      <GameSeoPage content={GAME_SEO_CONFIG.basketball} />
    </SEOLayout>
  );
}
